export const renderReactModule = (component, el, data) => {
  Promise.all([import('react'), import('react-dom')]).then(([{ 'default': React }, { 'default': ReactDom }]) => {
    const length = el.length;
    for (let i = 0; i < length; i++) {
      ReactDom.render(
        React.createElement(component, { ...data, ...el[i].dataset }),
        el[i]
      );
    }
  });
};
